import script from "./Thank.vue?vue&type=script&setup=true&lang=js"
export * from "./Thank.vue?vue&type=script&setup=true&lang=js"

import "./Thank.vue?vue&type=style&index=0&id=94cfe0ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94cfe0ce"]])

export default __exports__